import { createSlice } from "@reduxjs/toolkit";
import { ISnapShotSlice } from "../../../models/master/snapShot";


const initialSnapShotState: ISnapShotSlice = {
  snapShots: undefined,
  snapShot: undefined
};

const snapShotSlice = createSlice({
  name: "snapShot",
  initialState: initialSnapShotState,
  reducers: {
    setSnapShots: (state, action: { payload: any }) => {
      state.snapShots = action.payload;
    },
    setSnapShot: (state, action: { payload: any }) => {
      state.snapShot = action.payload;
    },

  },
});

export const { setSnapShots, setSnapShot } =
  snapShotSlice.actions;

const snapShotReducer = snapShotSlice.reducer;

export type snapShotState = ReturnType<typeof snapShotReducer>;

export default snapShotReducer;
